const config = {
  prefix: window.chatbotGlobalInfo?.storagePrefix || 'spcb_', // spcb for shopee chatbot
  wbStorage: null, // localStorage || sessionStorage
};

function setWbStorage(isLocal) {
  config.wbStorage = isLocal ? window.localStorage : window.sessionStorage;
}

function setItem(key, value, expire) {
  let v = { v: value, t: new Date().getTime(), e: typeof expire !== 'number' ? '' : expire };
  try {
    v = JSON.stringify(v);
  } catch (e) {
    throw new Error(`JSON数据格式异常：${e.message}`);
  }
  const wbStorage = config.wbStorage;
  key = `${config.prefix}${key}`;
  try {
    wbStorage.setItem(key, v);
  } catch (e) {
    const timer = setTimeout(() => {
      clearTimeout(timer);
      try {
        // 清除过期数据，重试一次
        clear();
        wbStorage.setItem(key, v);
      } catch (e) {
        throw new Error(`设置cache失败：${e.message}`);
      }
    }, 0);
  }
}

function getItem(key) {
  let o = config.wbStorage.getItem(`${config.prefix}${key}`);
  o = parseJSON(o);
  if (!o) {
    return o;
  }
  const e = o?.e;

  // 检查是否过期
  if (e === 0 || (e && (new Date() - o.t) >= e * 1000)) {
    removeItem(key);
    return '';
  }

  return o.v;
}

function removeItem(key) {
  try {
    config.wbStorage.removeItem(`${config.prefix}${key}`);
  } catch (e) {

  }
}

function clear() {
  const wbStorage = config.wbStorage;
  for (let i = wbStorage.length - 1 ; i >= 0; i--) {
    const key = wbStorage.key(i);
    key.indexOf(config.prefix) === 0 && getItem(key);
  }
}

function parseJSON(data) {
  if (!data || typeof data !== 'string') {
    return data;
  }
  data = data.replace(/^\s+|\s+$/g, '');
  if (!data) {
    return data;
  }

  try {
    data = JSON.parse(data);
  } catch (e) {

  }
  return data;
}

const local = {
  setItem(key, value, expire) {
    setWbStorage(true);
    setItem(key, value, expire);
  },
  getItem(key) {
    setWbStorage(true);
    return getItem(key);
  },
  removeItem(key) {
    setWbStorage(true);
    removeItem(key);
  },
  clear() {
    setWbStorage(true);
    clear();
  },
};

const session = {
  setItem(key, value, expire) {
    setWbStorage(false);
    setItem(key, value, expire);
  },
  getItem(key) {
    setWbStorage(false);
    return getItem(key);
  },
  removeItem(key) {
    setWbStorage(false);
    removeItem(key);
  },
  clear() {
    setWbStorage(false);
    clear();
  },
};

export default {
  local,
  session,
};
